import { useCallback } from 'react'

export function useOwner() {
  const assignOwnerAndDefault = useCallback((record) => {
    const newRecord = { ...record }
    const { assigneeId, salesTeamName, assigneeName } = newRecord.row

    if (assigneeId) {
      if (!assigneeId.value && salesTeamName?.value) {
        assigneeId.value = 'Unassigned'
      }

      if (assigneeId.value) {
        assigneeName.value = assigneeId.value.split(' - ')[0].trim()
      }
    }

    return newRecord
  }, [])

  return {
    assignOwnerAndDefault,
  }
}
